module.exports = __webpack_public_path__ + "static/media/pla_clear_gaint_straw2.04ba2901.png";